import { MarketType } from '@mg-platform/reports/reports-data-access'

export interface IDashboardLaborItem {
  displayText: string
  effectiveLaborRate: number
  effectiveLaborRateFormatted: string
  id: string
  marketType: MarketType
}

export interface IDashboardLaborResponse {
  items: IDashboardLaborItem[]
}
